export default {
  title: 'Prestazioni campagne recenti',
  recipients: '{{recipients}} destinatari',
  error_messages: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
